import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "qJTHM",
  "data-new-gr-c-s-check-loaded": "14.1086.0",
  "data-gr-ext-installed": ""
}
const _hoisted_2 = {
  id: "container",
  class: "haAclf",
  style: {"padding":"2px 10px"}
}
const _hoisted_3 = { class: "nsm7Bb-HzV7m-LgbsSe hJDwNd-SxQuSe MFS4be-JaPV2b-Ia7Qfc MFS4be-Ia7Qfc uaxL4e-RbRzK" }
const _hoisted_4 = { class: "nsm7Bb-HzV7m-LgbsSe-bN97Pc-sM5MNb" }
const _hoisted_5 = { class: "nsm7Bb-HzV7m-LgbsSe-Bz112c-haAclf" }
const _hoisted_6 = { class: "nsm7Bb-HzV7m-LgbsSe-Bz112c" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_icon = _resolveComponent("google-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "nsm7Bb-HzV7m-LgbsSe-MJoBVe" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_google_icon)
            ])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "nsm7Bb-HzV7m-LgbsSe-BPrWId" }, "Continue with Google", -1))
        ])
      ])
    ])
  ]))
}